import { apiFetch } from "./config.js";
/** Saves one person's feedback on one HP Genie answer (anyone signed in). */
export async function sendGenieFeedback(input) {
    return apiFetch("/regulation/feedback", { method: "POST", body: input });
}
/** Every piece of feedback, newest first (admins only). */
export async function listGenieFeedback(status = "all") {
    return apiFetch(`/regulation/feedback?status=${status}`);
}
/** Marks feedback resolved with what was done, or opens it again (admins only). */
export async function updateGenieFeedback(id, status, resolutionNote = "", useAsGuidance = true) {
    return apiFetch(`/regulation/feedback/${id}`, {
        method: "PATCH",
        body: { status, resolution_note: resolutionNote, use_as_guidance: useAsGuidance },
    });
}
/** How many items still wait for an admin, and how many of those are thumbs-down (admins only). */
export async function getGenieFeedbackSummary() {
    return apiFetch("/regulation/feedback/summary");
}
